"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseConfig = parseConfig;
const jtd_1 = __importDefault(require("ajv/dist/jtd"));
const configJsonSchema = {
    properties: {
        server: {
            properties: {
                frontend: {
                    properties: {
                        url: {
                            type: "string"
                        }
                    }
                },
                api: {
                    properties: {
                        baseUrl: {
                            type: "string"
                        },
                        endpoint: {
                            properties: {
                                token: {
                                    type: "string"
                                },
                                user: {
                                    type: "string"
                                },
                                integration: {
                                    type: "string"
                                }
                            }
                        }
                    }
                }
            }
        },
        git: {
            properties: {
                branchPrefix: {
                    type: "string"
                },
                commitMessageSuffix: {
                    type: "string"
                }
            }
        },
        gitHub: {
            properties: {
                clientId: {
                    type: "string"
                }
            }
        }
    },
    additionalProperties: false
};
/**
 * Parse the configuration from JSON.
 *
 * @param jsonConfig - the JSON containing the config.
 *
 * @returns a Config object.
 */
function parseConfig(jsonConfig) {
    // create a validating parser
    const ajv = new jtd_1.default();
    const parse = ajv.compileParser(configJsonSchema);
    // parse the json
    const data = parse(jsonConfig);
    if (data === undefined) {
        throw new Error("Unable to parse JSON: [" + parse.position + "] " + parse.message);
    }
    else {
        return data;
    }
}
//# sourceMappingURL=config.js.map